export const DEFAULT_AUTOCOMPLETE_MINIMUM_CHARACTERS = 3;
export const DEFAULT_AUTOCOMPLETE_RESULTS_PER_PAGE = 5;
export const DEFAULT_AUTOCOMPLETE_CURRENT_PAGE = 1;
export const DEFAULT_SUGGESTIONS_SIZE = 5;
